import axios from 'axios';
import Configuration from '@/services/common/configurationService';

export default class BaseApiService {
  constructor() {
    this.httpClient = axios;

    this.apiRoutes = Configuration.ApiEndpoints;
    this.apiEndPointsBuilder = Configuration.ApiEndpointsBuilder;
  }

  makeRequest(request) {
    const self = this;

    return request
      .then((response) => Promise.resolve(response.data))
      .catch((error) => {
        const isValidationError = error.response && error.response.status === 400;

        if (isValidationError) {
          const { data: model } = error.response;

          if (model.isModelStateErrors) {
            let errors = [];

            errors = self.constructor.getErrorMessagesList(model.data);

            return Promise.reject(errors);
          }

          return Promise.reject(model.data);
        }

        return Promise.reject(error);
      });
  }

  static getErrorMessagesList(serverErrors) {
    const result = [];
    const entries = Object.entries(serverErrors);

    for (let i = 0; i < entries.length; i += 1) {
      const serverErrorEntry = entries[i];
      const messages = serverErrorEntry[1];

      for (let j = 0; j < messages.length; j += 1) {
        const message = messages[j];
        result.push(message);
      }
    }

    return result;
  }
}
